var _path, _path2, _path3, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30737 8.36523H2.09302V7.75488H2.81812V5.57471L2.07349 5.73584V5.11084L3.58716 4.80566V7.75488H4.30737V8.36523Z",
    fill: "#144066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82788 12.5977V12.6123H4.24878V13.252H1.94409V12.6514L2.94751 11.6919C3.14933 11.4982 3.29093 11.3363 3.37231 11.2061C3.45532 11.0742 3.49683 10.9359 3.49683 10.791C3.49683 10.4688 3.32349 10.3076 2.97681 10.3076C2.6757 10.3076 2.38761 10.4272 2.11255 10.6665V9.98779C2.41691 9.79085 2.76034 9.69238 3.14282 9.69238C3.5009 9.69238 3.78003 9.78271 3.98022 9.96338C4.18205 10.1424 4.28296 10.3849 4.28296 10.6909C4.28296 11.0994 4.038 11.5218 3.5481 11.958L2.82788 12.5977Z",
    fill: "#144066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03687 17.8125V17.1411C2.27124 17.312 2.54468 17.3975 2.85718 17.3975C3.05412 17.3975 3.20711 17.3551 3.31616 17.2705C3.42684 17.1859 3.48218 17.0679 3.48218 16.9165C3.48218 16.7603 3.41382 16.6398 3.2771 16.5552C3.14201 16.4705 2.95565 16.4282 2.71802 16.4282H2.40308V15.8374H2.6936C3.14933 15.8374 3.3772 15.686 3.3772 15.3833C3.3772 15.0985 3.20223 14.9561 2.85229 14.9561C2.61792 14.9561 2.39006 15.0317 2.1687 15.1831V14.5532C2.41447 14.4295 2.70093 14.3677 3.02808 14.3677C3.38615 14.3677 3.66447 14.4482 3.86304 14.6094C4.06323 14.7705 4.16333 14.9797 4.16333 15.2368C4.16333 15.6942 3.9314 15.9806 3.46753 16.0962V16.1084C3.71493 16.1393 3.91024 16.2297 4.05347 16.3794C4.1967 16.5275 4.26831 16.7098 4.26831 16.9263C4.26831 17.2534 4.14868 17.5122 3.90942 17.7026C3.67017 17.8931 3.33976 17.9883 2.91821 17.9883C2.55688 17.9883 2.2631 17.9297 2.03687 17.8125Z",
    fill: "#144066"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.05615,
    y: 5.88428,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#144066"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.05615,
    y: 10.55,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#144066"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.05615,
    y: 15.35,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#144066"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/orderedList.060881201c26a45fcb69b2379755175c.svg";
export { ForwardRef as ReactComponent };